<div class="configurable-panel w-100">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h6>{{ title }}</h6>
    <div class="btn-config-box" >
      <button class="btn btn-sm btn-config rounded-1 me-3 px-2 disabled">
        <i class="bi bi-pencil-square me-1"></i> Pull
      </button>
      <button class="btn btn-sm btn-config rounded-1 px-2 disabled">
        <i class="bi bi-upload me-1"></i> Push
      </button>
    </div>
  </div>
  <ng-content></ng-content>
</div>
